import { render } from "./section-one.vue?vue&type=template&id=70529d87&scoped=true"
const script = {}

import "./section-one.vue?vue&type=style&index=0&id=70529d87&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70529d87"]])

export default __exports__